import React, {Component} from 'react';
import {Line, Bar, HorizontalBar, Pie, Polar, Doughnut,} from 'react-chartjs-2';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import _HauteFire from '../Utils/HauteFire';

const ReactHightMaps = require("react-highcharts/ReactHighmaps");
const maps = require('./mapdata/world');
const HauteFire = new _HauteFire();
const CLIENT_ID = "709476992106-rivfr8fpl1d3neqsjfq09de7nhgmtkqq.apps.googleusercontent.com";
const VIEW_ID = '162291646';

class Dashboard extends Component {
    constructor() {
        super();

        this.state = {
            authName: "",
            startDate: moment().subtract(7, 'days'),
            endDate: moment().subtract(1, 'days'),
            analyticsStartDate: HauteFire.getDateFormat(moment().subtract(7, 'days')._d),
            analyticsEndDate: HauteFire.getDateFormat(moment().subtract(1, 'days')._d),
            dateRanges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            mapCountryIsoCodes: [],
            lineSessionData: {},
            lineSourceData: {},
            barCountriesData: {},
            horizontalBarCitiesData: {},
            pieDeviceData: {},
            polarBrowserData: {},
            doughnutMobileDeviceData: {}
        };
    }

    componentDidMount() {
        const _this = this;

        _this.activateGoogleProfile();
    }

    activateGoogleProfile() {
        debugger;
        const _this = this;

        require("google-client-api")().then((gapi) => {
            gapi.client.init({
                apiKey: "AIzaSyBki2rnGdyw69pW9HjSSjPCyhSxxHZoygo",
                discoveryDocs: ["https://people.googleapis.com/$discovery/rest?version=v1"],
                clientId: CLIENT_ID,
                scope: "profile"
            }).then(() => {
                gapi.auth2.getAuthInstance().isSignedIn.listen(_this.makeGoogleAuthApi(gapi));
            })
        });
    }

    makeGoogleAuthApi(gapi) {
        const _this = this;

        gapi.client.people.people.get({
            'resourceName': 'people/me',
            'requestMask.includeField': 'person.names'
        }).then((response) => {
            let authName = response.result.names[0].givenName;
            _this.setState({authName});

            _this.loadGapi();
        }, (reason) => {
            console.error("Error ", reason.result.error.message);
        })
    }

    googleAuth() {
        const _this = this;
        require("google-client-api")().then((gapi) => {
            return gapi.auth2.getAuthInstance().signIn();
        }).then(() => {
            debugger;
            _this.activateGoogleProfile();
        });
    }

    loadGapi() {
        const _this = this;

        require("google-client-api")().then((gapi) => {
            gapi.client.init({
                'apiKey': "AIzaSyBki2rnGdyw69pW9HjSSjPCyhSxxHZoygo",
                'discoveryDocs': ["https://people.googleapis.com/$discovery/rest?version=v1"],
                'clientId': CLIENT_ID,
                'scope': "profile"
            }).then(() => {
                // // Listen for sign-in state changes.
                // gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
                // // Handle the initial sign-in state.
                // updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
                // gapi.auth2.getAuthInstance().signIn();

                _this.getCountryIsoCodes(gapi);
                _this.getSessions(gapi);
                _this.getCountries(gapi);
                _this.getCities(gapi);
                _this.getDevices(gapi);
                _this.getBrowserData(gapi);
                _this.getMobileDevices(gapi);
                _this.getSources(gapi);
            });
        });
    }

    changeDateRange(event, picker) {
        this.setState({
            startDate: picker.startDate,
            endDate: picker.endDate,
            analyticsStartDate: HauteFire.getDateFormat(picker.startDate._d),
            analyticsEndDate: HauteFire.getDateFormat(picker.endDate._d),
        }, () => {
            this.loadGapi()
        });
    }

    getCountryIsoCodes(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:countryIsoCode"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let mapCountryIsoCodes = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        const valNums = parseInt(row.metrics[0].values[0]);
                        if ((_dimension && valNums) != (undefined || "")) {
                            mapCountryIsoCodes.push({"hc-key": _dimension.trim().toLowerCase(), value: valNums});
                        }
                    }
                    if (mapCountryIsoCodes.length > 0) {
                        _this.setState({mapCountryIsoCodes});
                    }
                }
            }
        })
    }

    getSessions(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {
                                "endDate": _this.state.analyticsEndDate,
                                "startDate": _this.state.analyticsStartDate
                            }
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:date"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], sessions = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension) {
                            const _date = (_dimension.substring(_dimension.length - 2, _dimension.length) + "/" + _dimension.substring(_dimension.length - 4, _dimension.length - 2) + "/" + _dimension.substring(0, _dimension.length - 4));
                            if (_date != (undefined || "")) {
                                labels.push(_date);
                            }
                        }
                        const session = row.metrics[0].values[0];
                        if (session != (undefined || "")) {
                            sessions.push(parseInt(session));
                        }
                    }
                    if (labels.length == sessions.length) {
                        let lineSessionData = {
                            labels,
                            datasets: [
                                {
                                    label: "Sessions",
                                    data: sessions,
                                    backgroundColor: "rgb(63, 127, 191)"
                                }
                            ]
                        };
                        _this.setState({lineSessionData: lineSessionData});
                    }
                }
            }
        })
    }

    getSources(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:source"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], sources = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension != (undefined || "")) {
                            labels.push(_dimension);
                        }
                        const source = row.metrics[0].values[0];
                        if (source != (undefined || "")) {
                            sources.push(parseInt(source));
                        }
                    }
                    if (labels.length == sources.length) {
                        let lineSourceData = {
                            labels,
                            datasets: [
                                {
                                    label: "Sources",
                                    data: sources,
                                    backgroundColor: "#FF6384",
                                    fill: false
                                }
                            ]
                        };
                        _this.setState({lineSourceData: lineSourceData});
                    }
                }
            }
        })
    }

    getCountries(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:country"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], countries = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension != (undefined || "")) {
                            labels.push(_dimension);
                        }
                        const country = row.metrics[0].values[0];
                        if (country != (undefined || "")) {
                            countries.push(parseInt(country));
                        }
                    }
                    if (labels.length == countries.length) {
                        let barCountriesData = {
                            labels,
                            datasets: [
                                {
                                    data: countries,
                                    backgroundColor: HauteFire.rgbRandomColors(rows.length)
                                }
                            ]
                        };
                        _this.setState({barCountriesData: barCountriesData});
                    }
                }
            }
        })
    }

    getCities(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:city"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], cities = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension != (undefined || "")) {
                            labels.push(_dimension);
                        }
                        const city = row.metrics[0].values[0];
                        if (city != (undefined || "")) {
                            cities.push(parseInt(city));
                        }
                    }
                    if (labels.length == cities.length) {
                        let horizontalBarCitiesData = {
                            labels,
                            datasets: [
                                {
                                    data: cities,
                                    backgroundColor: HauteFire.rgbRandomColors(rows.length)
                                }
                            ]
                        };
                        _this.setState({horizontalBarCitiesData: horizontalBarCitiesData});
                    }
                }
            }
        })
    }

    getDevices(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:deviceCategory"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], devices = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension != (undefined || "")) {
                            labels.push(_dimension);
                        }
                        const device = row.metrics[0].values[0];
                        if (device != (undefined || "")) {
                            devices.push(parseInt(device));
                        }
                    }
                    if (labels.length == devices.length) {
                        let pieDeviceData = {
                            labels,
                            datasets: [
                                {
                                    data: devices,
                                    backgroundColor: HauteFire.rgbRandomColors(rows.length)
                                }
                            ]
                        };
                        _this.setState({pieDeviceData: pieDeviceData});
                    }
                }
            }
        })
    }

    getBrowserData(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:browser"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], browsers = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension != (undefined || "")) {
                            labels.push(_dimension);
                        }
                        const browser = row.metrics[0].values[0];
                        if (browser != (undefined || "")) {
                            browsers.push(parseInt(browser));
                        }
                    }
                    if (labels.length == browsers.length) {
                        let polarBrowserData = {
                            labels,
                            datasets: [
                                {
                                    data: browsers,
                                    backgroundColor: HauteFire.rgbRandomColors(rows.length)
                                }
                            ]
                        };
                        _this.setState({polarBrowserData: polarBrowserData});
                    }
                }
            }
        })
    }

    getMobileDevices(gapi) {
        const _this = this;
        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                        "viewId": VIEW_ID,
                        "dateRanges": [
                            {"endDate": _this.state.analyticsEndDate, "startDate": _this.state.analyticsStartDate}
                        ],
                        "metrics": [
                            {"expression": "ga:sessions"}
                        ],
                        "dimensions": [
                            {"name": "ga:mobileDeviceInfo"}
                        ]
                    }
                ]
            }
        }).then((response) => {
            if (response.status == 200) {
                if (response.result.reports.length > 0) {
                    const rows = response.result.reports[0].data.rows;
                    let labels = [], devices = [];
                    for (let row of rows) {
                        const _dimension = row.dimensions[0];
                        if (_dimension != (undefined || "")) {
                            labels.push(_dimension);
                        }
                        const device = row.metrics[0].values[0];
                        if (device != (undefined || "")) {
                            devices.push(parseInt(device));
                        }
                    }
                    if (labels.length == devices.length) {
                        let doughnutMobileDeviceData = {
                            labels,
                            datasets: [
                                {
                                    data: devices,
                                    backgroundColor: HauteFire.rgbRandomColors(rows.length)
                                }
                            ]
                        };
                        _this.setState({doughnutMobileDeviceData: doughnutMobileDeviceData});
                    }
                }
            }
        })
    }

    render() {
        const countryData = this.state.mapCountryIsoCodes;
        const start = this.state.startDate.format('YYYY-MM-DD');
        const end = this.state.endDate.format('YYYY-MM-DD');
        let label = start + ' - ' + end;
        if (start === end) {
            label = start;
        }

        var config = {
            chart: {
                spacingBottom: 20
            },
            title: {
                text: 'World map'
            },
            legend: {
                enabled: true
            },
            mapNavigation: {
                enabled: true,
                buttonOptions: {
                    verticalAlign: 'bottom'
                }
            },

            colorAxis: {
                min: 0
            },
            series: [{
                data: countryData,
                mapData: maps,
                joinBy: 'hc-key',
                name: '# sessions',
                states: {
                    hover: {
                        color: '#058DC7'
                    }
                },
                dataLabels: {
                    enable: true,
                    format: '{point.value}'
                }
            }]
        };

        return (
            <div>
                {this.state.authName != "" ?
                    <div>
                        <div className="card">
                            <div className="card-header" style={{backgroundColor: 'white !important'}}>
                                <span>Hello, {this.state.authName}</span>

                                <DateRangePicker startDate={this.state.startDate} endDate={this.state.endDate}
                                                 ranges={this.state.dateRanges}
                                                 onEvent={this.changeDateRange.bind(this)}>
                                    <button className="selected-date-range-btn" style={{width: 250}}>
                                        <div className="pull-left">
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                        </div>
                                        <div className="pull-right">
                                            <span>{label}</span>
                                        </div>
                                    </button>
                                </DateRangePicker>
                            </div>
                        </div>

                        <ReactHightMaps config={config}/>

                        <div className="animated fadeIn">
                            <div className="card-columns cols-2">
                                <div className="card">
                                    <div className="card-header">
                                        Sessions
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <Line data={this.state.lineSessionData}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        Sources
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <Line data={this.state.lineSourceData}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        Countries
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <Bar data={this.state.barCountriesData}
                                                 options={{
                                                     legend: {display: false},
                                                     title: {display: true, text: 'Countries'}
                                                 }}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        Cities
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <HorizontalBar data={this.state.horizontalBarCitiesData}
                                                           options={{
                                                               legend: {display: false},
                                                               title: {display: true, text: 'Cities'}
                                                           }}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        Devices
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <Pie data={this.state.pieDeviceData} options={{
                                                legend: {display: false},
                                                title: {display: true, text: 'Devices'}
                                            }}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        Browser
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <Polar data={this.state.polarBrowserData}
                                                   options={{
                                                       legend: {display: false},
                                                       title: {display: true, text: 'Browser'}
                                                   }}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        Mobile Devices
                                    </div>
                                    <div className="card-block">
                                        <div className="chart-wrapper">
                                            <Doughnut data={this.state.doughnutMobileDeviceData}
                                                      options={{
                                                          legend: {display: false},
                                                          title: {display: true, text: 'Mobile Devices'}
                                                      }}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <button onClick={this.googleAuth.bind(this)}>
                            <i className="fa fa-google fa-2x" aria-hidden="true"></i> Sign In
                        </button>
                    </div> }

            </div>
        )
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js